module.exports = __webpack_public_path__ + "media/images/countrysquared/aq-134edb0edb2c6e07871c0b7ff06ff698.svg";